module.exports = __webpack_public_path__ + "static/media/zheng2-2@2x.eb15351b.png";